"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardButton = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@material-ui/core");
var CardButton_styles_1 = require("./CardButton.styles");
var enums_1 = require("../../enums");
var ChevronRight_1 = tslib_1.__importDefault(require("@material-ui/icons/ChevronRight"));
var cardbuttonHelper_1 = require("./cardbuttonHelper");
var CardButton = function (_a) {
    var onClick = _a.onClick, _b = _a.name, name = _b === void 0 ? 'signa-card-button' : _b, title = _a.title, description = _a.description, icon = _a.icon, _c = _a.color, color = _c === void 0 ? enums_1.CardColor.primary : _c, _d = _a.arrowIcon, arrowIcon = _d === void 0 ? true : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e;
    var classes = (0, CardButton_styles_1.useButtonStyles)();
    var classDisabled = (0, cardbuttonHelper_1.getContainerColorAndDisabledClassesMap)(classes, color);
    var classContainedColor = (0, cardbuttonHelper_1.getContainedColorClassesMap)(classes, color);
    return (react_1.default.createElement(core_1.Button, { classes: {
            root: classes.root,
            disabled: classDisabled,
        }, className: "".concat(classContainedColor), disabled: disabled, "data-signa": name, onClick: onClick, variant: "contained" },
        react_1.default.createElement("div", { className: classes.content, "data-signa": "content-".concat(name) },
            react_1.default.createElement("div", { className: "leftIcon" }, icon),
            react_1.default.createElement("div", { className: classes.text },
                react_1.default.createElement(core_1.Typography, { "data-signa": "title-".concat(name), className: classes.title, variant: "body1", style: { marginBottom: '0' } }, title),
                react_1.default.createElement(core_1.Typography, { className: "subtitle", "data-signa": "description-".concat(name), variant: "body2", style: { marginBottom: '0' } }, description)),
            arrowIcon && react_1.default.createElement(ChevronRight_1.default, { className: "rightIcon", fontSize: "default", "data-signa": "icon-".concat(name) }))));
};
exports.CardButton = CardButton;
